export default __webpack_public_path__ + "static/media/Storage-Accounts.7758c39b.svg";